import axios from 'axios'

export default () => {
  const options = {
    baseURL: process.env.API_URL,
    headers: {'Authorization': `Bearer ${localStorage.accessToken}`}
  }
  return axios.create(options)
}



// WEBPACK FOOTER //
// ./src/services/Api.js